// extracted by mini-css-extract-plugin
export default {"wrap":"nC-z","fullWidth":"oC-z","searchPlacement":"pC-z","items":"qC-z","featureCss":"rC-z","disabled":"sC-z","imgCss":"tC-z"};